import { Box } from "@mui/material";
import TabContainorBasic from "./TabContainorBasic";
import TabContainorMultiMedia from "./TabContainorMultiMedia";

const EntityTabContainor = ({ tabIndex, editableEntityData, setEditableEntityData, artists, global_constant, createQuestions, getMultiMediaByEntityId, editableEntityMultimediaData }) => {
    return (
        <Box sx={{
            flex: 1,
            mt: 0,
            overflowY: 'auto',
            paddingRight: 1,
            paddingLeft: 1,
            paddingBottom: 0,
            maxHeight: 'calc(100vh - 160px)', // Adjust height depending on tab + button height
        }}>
            {tabIndex === 0 && (
                <TabContainorBasic
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    artists={artists}
                    global_constant={global_constant}
                    createQuestions={createQuestions}
                />
            )}
            {tabIndex === 1 && (
                <TabContainorMultiMedia editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} global_constant={global_constant} getMultiMediaByEntityId={getMultiMediaByEntityId} editableEntityMultimediaData={editableEntityMultimediaData} artists={artists} />
            )}
        </Box>
    );
}

export default EntityTabContainor;